export default "__VITE_ASSET__BpJNEOVk__"